import React from 'react'
import Modal from 'react-modal'
import { useState } from 'react'
import { Formik, Form } from 'formik'
import { Loader } from 'components/loader/loader'
import { loginUser } from 'context/actions';
import { useAuthDispatch } from 'context/index';
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next';
import { userLang } from 'components/utils'
import { ReactComponent as ClearIcon } from 'assets/images/svg/clear-icon.svg';
import {TextField} from '../inputs/TextField';

Modal.setAppElement('#root')

export const LoginModal = ({
  isOpen,
  setIsOpen,
  setMidlwarePassResetModal,
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const [backendError, setBackandError] = useState('')
  const { t } = useTranslation();
  const customStyles = {
    overlay: {
      backgroundColor: 'rgba(47, 128, 237, 0.5)',
      position: 'fixed',
      display: 'flex',
      justifyContent: 'center',
      top: '0',
      left: '0',
      width: '100%',
      height: '100%',
      zIndex: 9,
      overflowY: 'auto',
    },
    content: {
      position: 'absolute',
      backgroundColor: '#FFFFFF',
      borderRadius: '10px',
      height: 'fit-content',
      margin: '10px auto',
      maxWidth: '540px',
      width: '95%',
      outlineWidth: 0,
    },
  }

  const validate = (values) => {
    // setVisible(true)
    const errors = {}
    if (!values.email) {
      errors.email = t('required')
    }
    if (
      values.email &&
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
    ) {
      errors.email = t('invalidMail')
    }
    if (!values.password) {
      errors.password = t('required')
    }
    if (values && values.password && values.password.length <= 5) {
      errors.password = t('passLength')
    }
    return errors
  }
  const history = useHistory()
  const dispatch = useAuthDispatch();

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => {
        setIsOpen(false)
      }}
      overlayClassName={'modal_overlay'}
      className={'modal-login'}
      style={customStyles}
      contentLabel="Авторизация"
      shouldCloseOnOverlayClick={true}
    >
      <div className="modal__phone">

          <div className="modal__head">
              <h2 className="modal__title">{t('auth')}</h2>

              <button className="modal__close" onClick={() => setIsOpen(false)}>
                  <ClearIcon />
              </button>
          </div>

        <div className="modal__wrap">
          <div className="modal__subtitle">
            {t('authText')}
          </div>
          <Formik
            initialValues={{ email: '', password: '' }}
            validate={(values) => {
              return validate(values)
            }}
            onSubmit={async (values, { setFieldError }) => {
              setIsLoading(true)
              return await loginUser(dispatch, {
                ...values, locale: userLang()
              }).then((resp) => {
                if (resp.access_token) {
                  return history.push('/profile')
                }
                else {
                  const { errors } = resp
                    setBackandError(errors.password[0])
                }

              }).catch((e) => {
                const { errors } = e.response.data
                setBackandError(errors.password[0])
              })
                .finally(() => setIsLoading(false))
            }
            }
          >
            {({
                values,
              errors,
              touched,
              handleSubmit,
                  handleChange
            }) => (
              <Form
                className="authorization__form authorization__form_2 js-authorization-form"
                onSubmit={handleSubmit}
              >
                <div className="authorization__input-group phone">
                  <div className="authorization__input-block">
                      <TextField
                          name="email"
                          error={touched.email && errors.email}
                          value={values.email}
                          placeholder={t('email')}
                          handleChange={handleChange}
                      />
                  </div>
                  <div className="authorization__input-block">
                      <TextField
                          name="password"
                          error={touched.password && errors.password}
                          value={values.password}
                          placeholder={t('password')}
                          handleChange={handleChange}
                          type="password"
                      />
                  </div>


                </div>
                  <div style={{ position: 'relative', marginTop: 5 }}>
                        <span className="authorization__error">
                         {backendError}
                      </span>
                  </div>
                <div className="authorization__input-group buttons">
                  <div className="authorization__input-button">
                    <button
                      className="btn btn_clean authorization__btn-submit button"
                      type="button"

                      onClick={() => {
                        return [setMidlwarePassResetModal(true),setIsOpen(false)]
                      }}
                    >
                      <span
                          style={{
                              fontSize: 16,
                              color: '#2F80ED',
                              textAlign: 'left',
                              textTransform: 'none',
                              fontWeight: 400
                          }}
                      >{t('restorePass')}</span>
                    </button>
                  </div>
                  <div className="authorization__input-button">
                    <button
                      className="btn btn-red authorization__btn-submit button"
                      type="submit"
                    // disabled={!isValid || isLoading}
                    >
                      {isLoading && <Loader />}
                      <span style={{ opacity: isLoading ? 0 : 1 }}>
                      {t('login_btn')}
                      </span>
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </Modal>
  )
}
